import { apiRoutes } from 'routes';
import Fetcher from 'utils/fetcher';
import { TableFilterQueryParams } from 'types/tableFilter';
import { IContactRelation } from 'domain/contactRelation/types';

export type IndexParams = {
  clientId: ID;
  queryParams: TableFilterQueryParams;
};

const ContactRelationsRepository = {
  index({ clientId, queryParams }: IndexParams): Promise<CollectionResponse<'contactRelations', IContactRelation[]>> {
    const url = apiRoutes.apiSiteV1ClientContactRelationsPath(clientId);
    return Fetcher.get(url, queryParams);
  },
};

export default ContactRelationsRepository;
